import React, { useEffect, useState } from "react";
import styles from "./WrapperDetail.module.scss";
import WrapperDetailCard from "../WrapperDetailCard/WrapperDetailCard";
import useWindowResize from "../../hooks/useWindowResize";
import EventCard from "../EventCard/EventCard";
import Envelope from "../../public/assets/icons/envelope.svg";
import Phone from "../../public/assets/icons/phone.svg";
import Whatsapp from "../../public/assets/icons/whatsapp.svg";
import BoutiqueButton from "../BoutiqueButton/BoutiqueButton";

const WrapperDetail = ({
  event = false,
  leftContent,
  rightContent,
  pastEvent = false,
}) => {
  const [readmore, setReadMore] = useState(false);
  const [leftItem, setLeftItem] = useState();
  const isBelowLarge = useWindowResize(968);
  const [preview, setPreview] = useState();
  // const [more, setMore] = useState([]);
  const [uniqueParagraph, setuniqueParagraph] = useState(false);

  const handleClick = () => {
    setReadMore(!readmore || forceReadMore);
  };

  let forceReadMore = rightContent && rightContent.text && (rightContent.text.indexOf('<iframe') != -1 || rightContent.text.indexOf('<video'));
  useEffect(() => {
    if (isBelowLarge) {
      setReadMore(false || forceReadMore);
    } else {
      setReadMore(true);
    }
  }, [isBelowLarge]);

  const getArrayTagsHtmlString = (str) => {
    let htmlSplit = str.split("</p>");
    let arrayElements = [];
    let nodeElement = "";
    for (let i = 0; i < htmlSplit.length - 1; i++) {
      nodeElement = htmlSplit[i] + "</p>";
      arrayElements.push(nodeElement);
    }
    if (arrayElements.length == 1) {
      setPreview(arrayElements[0].split(" ").slice(0, 19).join(" ") + "</p>");
      setuniqueParagraph(true);
    } else if (arrayElements.length == 2) {
      setPreview(arrayElements[0].split(" ").slice(0, 19).join(" ") + "</p>");
      setuniqueParagraph(true);
    } else {
      setPreview(arrayElements[0]);
    }
  };

  useEffect(() => {
    if (!pastEvent && leftContent) {
      if (event && leftContent.title && leftContent.text) {
        setLeftItem(
          <EventCard
            title={leftContent.title}
            dates={leftContent.dates}
            hour={leftContent.hour}
            links={leftContent.links}
          />
        );
      } else {
        setLeftItem(
          <WrapperDetailCard
            title={leftContent.title}
            brandImg={leftContent.image}
            titleCategories={leftContent.titleCategories}
            category={leftContent.category}
            info={leftContent.titleInfo}
            content={leftContent.text}
            links={leftContent.links}
          />
        );
      }
    }
    if (rightContent.text) {
      getArrayTagsHtmlString(rightContent.text.replace(/ /g, ' '));
    }
  }, [leftContent, rightContent, pastEvent]);

  return (
    <div className={styles.wrapperDetail} style={{ display: pastEvent ? "block" : null }}>
      <div className={event ? null : styles.wrapperDetailCard}>{leftItem}</div>
      <div
        className={pastEvent ? styles.rightContentLarge : styles.rightContent}
      >
        <div className={styles.title}>{rightContent.title}</div>
        <div className={styles.subtitle}>{rightContent.subtitle}</div>
        <div
          dangerouslySetInnerHTML={{ __html: preview }}
          className={`${styles.content} ${uniqueParagraph ? styles.noMarginBottom : null
            }`}
          style={{ display: readmore ? "none" : null }}
        ></div>
        {
          rightContent?.text &&
          <div
            dangerouslySetInnerHTML={{
              __html: rightContent.text.replace(/ /g, ' '),
            }}
            className={`${styles.contentClosed} ${styles.content} ${readmore ? styles.contentOpen : null
              }`}
          ></div>
        }
        {!forceReadMore && <div className={styles.readMore} onClick={handleClick}>
          {rightContent.readMore}
          <button className={styles.accordionButton}>
            <div className={readmore ? styles.hideLineFirst : null}></div>
            <div className={readmore ? styles.hideLine : null}></div>
          </button>
        </div>}
        {rightContent.contacts && (
          <div className={styles.social} style={{ textAlign: pastEvent ? "center" : null }}>
            {rightContent.contacts.follow && <><p
              style={{
                justifyContent: !pastEvent ? null : "center",
                marginTop: !pastEvent ? null : "4.25rem",
                flexDirection: !pastEvent ? null : "row",
              }}
            >
              {rightContent.contacts.followTitle}
            </p>
            <div
              className={styles.tags}
            >
              {rightContent.contacts.follow}
            </div></>}
            {rightContent.contacts.links &&
              rightContent.contacts.links.length > 0 &&
              rightContent.contacts.book && (
                <p>
                  {rightContent.contacts.book}
                  <div className={styles.icons}>
                    <a href={rightContent.contacts.links[0]?.url}>
                      <Envelope />
                    </a>
                    <a href={rightContent.contacts.links[1]?.url}>
                      <Phone />
                    </a>
                    <a href={rightContent.contacts.links[2]?.url}>
                      <Whatsapp />
                    </a>
                  </div>
                </p>
              )}
          </div>
        )}
        {rightContent.eboutique?.links && rightContent.eboutique?.links.length &&
          <div className={styles.eboutiqueSection}>
            {rightContent.eboutique?.title && <div className={styles.subtitle}>{rightContent.eboutique.title}</div>}
            {rightContent.eboutique?.links.length == 1 && 
              <div>
                <BoutiqueButton data={{ links: rightContent.eboutique.links }} />
              </div>
            }
            {rightContent.eboutique?.links.length > 1 && 
              <div>
                <BoutiqueButton data={{ links: rightContent.eboutique.links }} />
              </div>
            }
          </div>
        }
      </div>
    </div>
  );
};

export default WrapperDetail;
